module.exports = __webpack_public_path__ + "static/media/bytt-nn-1.ca3c33a7.mp3";